<template>
  <div class="userList electricityBill">
    <!-- 财务报表 newFinanceReport-->
    <div class="content">
      <!-- <div class="userList-top">
        <span style="font-size:16px">财务报表</span>
        <div class="btns" style="z-index: 8;"> 
          报表导出:<el-date-picker size="mini" v-model="value1" :picker-options="pickerOptions" type="month"
            @change="daochu" placeholder="选择月" />
        </div>
      </div> -->
      <div class="search">
        <el-form ref="form" :model="form" label-width="92px" size="medium" style="display: flex;width: auto;">
          <el-form-item label="项目名称">
            <el-input v-model="form.unitName" placeholder="请输入项目名称" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="form.ownerName" placeholder="请输入用户名" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="用户编号">
            <el-input v-model="form.rfid" placeholder="请输入用户编号" class="el-input-mysmall"></el-input>
          </el-form-item>
          <el-form-item label="时间：">
            <el-date-picker v-model="form.queryTime" :picker-options="pickerOptions" type="month" style="width: 110px;"
              placeholder="选择月" />
          </el-form-item>
        </el-form>
        <el-button type="primary" size="mini" @click="search" class="search-btn">查询</el-button>
        <el-button type="primary" size="mini" @click="daochu" class="search-btn">导出</el-button>
      </div>

      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table ref="table" :data="tableData2" v-loading="loading" stripe style="width: 100%"
          :max-height="heights - 20" lazy row-key="租户id" @expand-change="load" border>
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.children" style="width: 100%" v-loading="loading2"
                header-row-class-name="tableNest">
                <template slot="empty">
                  <span class="noData">
                    <img src="../../assets/noData.png" alt="暂无数据">
                    <span class="text">暂无数据</span>
                  </span>
                </template>

                <el-table-column prop="表号" label="表号" min-width="120" align="center" />
                <el-table-column prop="上月读数" label="上月读数" min-width="120" align="center" />
                <el-table-column prop="本月单价" label="本月单价" min-width="120" align="center" />
                <el-table-column prop="本月电费" label="本月电费" min-width="120" align="center" />
                <el-table-column prop="本月电量" label="本月电量" min-width="120" align="center" />
                <el-table-column prop="本月读数" label="本月读数" min-width="120" align="center" />

              </el-table>
            </template>
          </el-table-column>
          <el-table-column type="index" label="序号" width="90" align="center" />
          <el-table-column prop="项目名称" label="项目名称" min-width="137" align="center" />
          <el-table-column prop="商铺号" label="商铺号" min-width="137" align="center" />
          <el-table-column prop="租户名" label="租户名称" min-width="137" align="center" />
          <el-table-column prop="品牌名称" label="品牌名称" min-width="137" align="center" />
          <el-table-column prop="本月充值金额" label="本月充值金额" min-width="137" align="center" />
          <el-table-column prop="累计充值" label="累计充值金额" min-width="137" align="center" />
          <el-table-column prop="上月充值金额" label="上月充值金额" min-width="137" align="center" />
          <el-table-column prop="上月余额" label="上月余额" min-width="137" align="center" />
          <el-table-column prop="本月余额" label="本月余额" min-width="137" align="center" />

          <!-- <el-table-column label="操作" align="center" width="400">
            <template #default="{row}">
         

            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[15, 25, 35, 45, 55]" :page-size="15" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 详情 -->
    <el-dialog title="详情" v-dialogDrag :visible.sync="detail_status" width="400" center>
      <el-table :data="childrenList" style="width: 100%" header-row-class-name="tableNest">
        <el-table-column prop="业主名" label="业主名" min-width="80" align="center" />
        <el-table-column prop="合计费用" label="合计费用" min-width="110" align="center" />
        <el-table-column prop="开始时间" label="开始时间" min-width="220" align="center" />
        <el-table-column prop="开始读数" label="开始读数" min-width="110" align="center" />
        <el-table-column prop="用电量" label="用电量" min-width="70" align="center" />
        <el-table-column prop="结束时间" label="结束时间" min-width="220" align="center" />
        <el-table-column prop="结束读数" label="结束读数" min-width="110" align="center" />
        <el-table-column prop="表名" label="表名" min-width="220" align="center" />
      </el-table>
      <el-pagination layout="prev, pager, next" :total="children_total" @current-change="changeFn" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="detail_status = false">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import {findOperatingRecord,findRecordType} from "../../api/zhongshanMeter";
  import resourcesStore from '@/cache/resourcesStore.js'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      downloadTable
    },
    data () {
      return {
        value1: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        baseUrl: DWSystemSetting.baseURL,
        uniId: this.$store.unitStore.getters.getNowUnit.id,
        loadingBtn: false,
        children_total: 0,
        children_params: {},//请求参数
        detail_status: false,//详情弹窗
        childrenList: [],//详情数据
        loading2: false,
        tableData3: [{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },{
          a: '1234567',
          b: '500.00',
          c: '200.00',
          d: '200.00',
          e: '200.00',
          f: '2.00',
        },],
        tableData2: [{
          '项目名称': '客厅',
          '商铺号': 1,
          '租户名': '租户A',
          '本月充值金额': '',
          '累计充值': '',
          '上月充值金额': '',
          '上月余额': '',
          '本月余额': '',
          '表号': '表号1',
          '上月读数': '',
          '本月读数': '',
          '本月电量': '',
          '本月单价': '',
          '本月电费': '',
          '备注': '',

        }],
        heji: {},//合计
        heights: document.getElementById('app').clientHeight-300,//屏幕高度 - 导航栏高度
        // 操作类型
        recordTypeList: [],
        //加载中
        loading: false,
        form: {
          queryType: 'DAY',
          queryTime: new Date()
        },
        searchflag: false,//是否搜索过
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 15,
        tableData: [],//表格数据 
        startDate: '',//日期
        endDate: new Date().getTime(),//日期
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>(Date.now()-86400000);
          }
        },
      };
    },

    mounted () {
      this.search() //获取列表数据

    },
    methods: {
      // 导出
      daochu (v) {
        const link=document.createElement('a');
        link.style.display='none';
        link.href=this.baseUrl+'/revenueManagement/exportFinancialStatements?queryType=MON&unitId='+this.uniId+'&queryTime='+this.form.queryTime.getTime()
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      // 详情分页
      changeFn (v) {
        var params=this.children_params;
        params.pageIndex=v;
        request({url: "/revenueManagement/getElectricityBill.do",method: "get",params}).then(res => {

          if(res.success) {
            this.childrenList=res.data.dataList;
            this.children_total=res.data.total;
          }
        })
      },
      detailFn (v,row) {

        this.detail_status=true;
        var d=row.billName.slice(0,10);
        d=d? new Date(d).getTime():0;
        var params={
          'userId': row.user_id,
          'queryTime': d,
          'pageIndex': 1,
          'pageSize': 10,
          'deviceNos': v,
          'queryType': row.billTypeEnum
        }
        this.$router.push({
          name: 'electricityList',
          query: {
            params
          }
        })
        return
        this.children_params=params;
        request({url: "/revenueManagement/getElectricityBill.do",method: "get",params}).then(res => {

          if(res.success) {
            this.childrenList=res.data.dataList;
            this.children_total=res.data.total;
          }
        })
      },
      // 懒加载
      load (row,en) {
        // this.tableData2.map(v => {
        //   if(v['租户id']!=row['租户id']) {
        //     this.$refs.table.toggleRowExpansion(v,false)
        //   }
        // })
        if(!en.length||row.children) {
          return
        }
        var params={
          'ownerId': row['租户id'],
          queryDate: this.form.queryTime.getTime()
        }
        this.loading2=true;
        setTimeout(() => {
          this.loading2=false;
        },3000);
        request({url: "/revenueManagement/getFinancialDeviceRecordList",method: "get",params}).then(res => {
          console.log(res,12);
          this.loading2=false;
          if(res.success) {
            row.children=res.data.dataList;
          } else {
            row.children=[]
          }
        })
      },
      //搜索
      search () {
        this.searchflag=true;//已搜索
        // pageIndex
        // pageSize
        // queryType
        // unitName
        // rfid
        // ownerName
        var params={
          unitId: this.uniId,
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          unitName: this.form.unitName,
          'queryType': 'MON',
          ownerName: this.form.ownerName,
          rfid: this.form.rfid,
          queryTime: this.form.queryTime.getTime(),
        }
        this.loading=true;
        setTimeout(() => {
          this.loading=false;
        },3000);
        request({url: "/revenueManagement/getFinancialStatements",method: "get",params}).then(res => {
          this.loading=false;
          if(res.success) {
            this.tableData2=res.data.dataList
            this.total=res.data.total
          } else {
            this.tableData2=[]
            this.total=0
          }
        })
      },
      // 获取列表信息
      getDataList () {
        var params={
          uniId: this.uniId,
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
        }
        this.loading=true
        request({url: "/revenueManagement/searchSettlementBill.do",method: "get",params}).then(res => {
          this.loading=false
          if(res.success) {
            this.tableData2=res.data.dataList
            this.total=res.data.total

          }
        })
      },



      //下载表格excel
      exportList (v) {

        // this.$store.unitStore.getters.getNowUnit
        return
        // 用户名，项目名称，用户编号
        var params={
          username: '',
          entityName: '',
          rfid: ''
        }


        request({url: "/revenueManagement/exportFinancialStatements",method: "get",params}).then(res => {
          const link=document.createElement('a');
          let blob=new Blob([res],{type: 'application/x-excel'});
          link.style.display='none';
          link.href=URL.createObjectURL(blob);
          link.download='财务报表.xls';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })

      },
      openDownloadFile (urlObj,saveName) {
        var openDownload=function(href,fileName) {
          var downloadElement=document.createElement('a');
          downloadElement.target="_blank";
          downloadElement.href=href;
          downloadElement.download=fileName||""; // HTML5新增的属性，指定保存文件名，可以不要后缀
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
        }

        if(typeof urlObj=='object'&&urlObj instanceof Blob) {
          if(window.navigator&&window.navigator.msSaveOrOpenBlob) {
            //针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
            window.navigator.msSaveOrOpenBlob(urlObj,saveName);
          } else {
            var url=window.URL.createObjectURL(urlObj); // 创建blob地址
            openDownload(url,saveName);
            window.URL.revokeObjectURL(url); // 释放掉blob对象创建的地址
          }
        } else {
          openDownload(urlObj,saveName);
        }
      },
      //分页功能
      newgetNowPageDataList (v) {
        // 当前页显示
        if(this.searchflag) {
          this.search()
        } else {
          this.search()
        }
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<style>
  .electricityBill .tableNest th {
    background-color: #f5f8fa !important;
    color: #999 !important;
  }

  .electricityBill .el-table__expanded-cell {
    background-color: #f5f8fa !important;
  }

  .electricityBill .el-table__expanded-cell {
    padding: 5px;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 44px;
  }
</style>
<style lang="scss" scoped>
  .box {
    display: flex;
    border: 1px solid #E6E6E6;
    justify-content: space-between;
    margin: 20px;
    height: 100px;
    box-sizing: border-box;
    padding: 20px 0;
  }

  .box .li {
    flex: 1;
    display: flex;
    justify-content: center;
    border-left: 1px solid #E6E6E6;
  }

  .box .li img {
    margin-right: 15px;
  }

  .box .li .t {
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
  }

  .box .li .b {
    font-size: 16px;
    font-weight: 400;
    color: #999;
  }

  .box .li:nth-child(1) {
    border-left: none;
  }

  .userList {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      overflow: hidden;

      .userList-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // height: 50px;
        margin: 0px 20px;
        padding: 20px 0px 12px 0px;
        border-bottom: 2px solid #E6E6E6;

        .user-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #359eff;
              font-weight: bold;
              border-bottom: 2px solid #359eff;
            }
          }
        }



      }

      .search::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        background-color: #d7d7d7;
      }

      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;
        left: -3px;
        overflow-y: hidden;

        .el-form-item {
          margin-bottom: 0px;
        }

        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 350px;
        }
      }

      .userList-table {
        margin: 0px 20px;

        .el-table th {
          border-right: 1px solid #E6E6E6;
        }

        .el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }





      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        margin-right: 15px;
      }

    }

    .el-form-item__label {
      padding: 0px;
    }



  }
</style>